
import React from 'react';
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { Form } from '@/components/ui/form';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AtivoFormFields } from './AtivoFormFields';
import { EditAtivoDialogHeader } from './EditAtivoDialogHeader';
import { EditAtivoDialogActions } from './EditAtivoDialogActions';
import { AtivoLogs } from './AtivoLogs';
import { AssetRelationships } from './AssetRelationships';
import { AtivoDiscovery } from './AtivoDiscovery';
import { useEditAtivoForm } from '@/hooks/useEditAtivoForm';
import { Ativo } from '@/types/ativo';
import { History, Network, ScanSearch } from 'lucide-react';

interface EditAtivoDialogProps {
  ativo: Ativo;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const EditAtivoDialog = ({ ativo, open, onOpenChange }: EditAtivoDialogProps) => {
  const { form, onSubmit, isSubmitting } = useEditAtivoForm({
    ativo,
    open,
    onSuccess: () => onOpenChange(false),
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[95vh] overflow-hidden flex flex-col">
        <EditAtivoDialogHeader ativo={ativo} />

        <Tabs defaultValue="form" className="w-full flex flex-col flex-1 min-h-0">
          <TabsList className="grid w-full grid-cols-4 flex-shrink-0">
            <TabsTrigger value="form">Formulário</TabsTrigger>
            <TabsTrigger value="history">
              <History className="h-4 w-4 mr-2" />
              Histórico
            </TabsTrigger>
            <TabsTrigger value="relationships">
              <Network className="h-4 w-4 mr-2" />
              Relacionamentos
            </TabsTrigger>
            <TabsTrigger value="discovery">
              <ScanSearch className="h-4 w-4 mr-2" />
              Discovery
            </TabsTrigger>
          </TabsList>

          <TabsContent value="form" className="mt-6 flex-1 overflow-y-auto">
            <Form {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
                <AtivoFormFields form={form} />
                
                <EditAtivoDialogActions
                  onCancel={() => onOpenChange(false)}
                  isSubmitting={isSubmitting}
                />
              </form>
            </Form>
          </TabsContent>

          <TabsContent value="history" className="mt-6 flex-1 overflow-y-auto">
            <AtivoLogs ativoId={ativo.id} />
          </TabsContent>

          <TabsContent value="relationships" className="mt-6 flex-1 overflow-hidden">
            <AssetRelationships
              assetId={ativo.id}
              assetName={ativo.nome}
            />
          </TabsContent>

          <TabsContent value="discovery" className="mt-6 flex-1 overflow-y-auto">
            <AtivoDiscovery ativoId={ativo.id} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
